import React, { ReactNode, MouseEvent } from "react";
import classNames from "classnames";

type ButtonProps = {
	variant?: "primary" | "secondary" | "tertiary" | "text" | "icon" | "link";
	icon?: ReactNode;
	iconPosition?: "left" | "right";
	state?: "default" | "disabled";
	size?: "small" | "medium" | "large" | "standard";
	children: ReactNode;
	disabled?: boolean;
	onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
	className?: string; // Add the className prop
};

const Button = ({
	variant = "primary",
	icon,
	iconPosition = "left",
	state = "default",
	size = "medium",
	children,
	disabled = false,
	onClick,
	className, // Destructure the className prop
}: ButtonProps) => {
	const baseClasses =
		"inline-flex items-center justify-center font-medium rounded focus:outline-none ";
	const sizeClasses = {
		small: "p-2 text-sm",
		medium: "p-3 text-base ",
		large: "p-6 text-lg",
		standard: "p-2 text-base",
	};
	const variantClasses = {
		primary: "bg-primaryBlue text-white ",
		secondary:
			"text-DeepTurquoise bg-transparent border border-DeepTurquoise hover:bg-DeepTurquoise active:bg-DeepTurquoise hover:text-white active:text-white ",
		tertiary: "bg-gray-300 text-gray-800 hover:bg-gray-400 active:bg-opacity-60",
		text: "bg-transparent text-DeepTurquoise",
		icon: "p-2 bg-gray-600 text-white", 
		link: "bg-transparent text-DeepTurquoise underline",
	};
	const stateClasses = {
		default: "",
		disabled: "opacity-50 cursor-not-allowed",
	};

	const classes = classNames(
		baseClasses,
		sizeClasses[size],
		variantClasses[variant],
		stateClasses[state],
		{ "pointer-events-none": disabled },
		className, // Add the custom className here
	);

	return (
		<div>
			<button className={classes} onClick={onClick} disabled={disabled}>
				{icon && iconPosition === "left" && variant !== "icon" && <span className="mr-2 hidden md:block">{icon}</span>}
				{children}
				{icon && iconPosition === "right" && variant !== "icon" && <span className="ml-2 hidden md:block">{icon}</span>}
				{icon && variant === "icon" && <span>{icon}</span>}
			</button>
		</div>
	);
};

export default Button;
